import { ActivatedRouteSnapshot } from '@angular/router';
// RxJs
import { Observable, of } from 'rxjs';
import { take, filter } from 'rxjs/operators';

import { PlEntityCollectionService } from './pl-entity-collection.service';

export class PlEntityDetailResolver<T> {
  constructor(
    private routeParamId: string,
    private entity: PlEntityCollectionService<T>
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<T> {
    const uuid = route.params[this.routeParamId];
    if (!uuid) {
      return of(null);
    }
    return this.entity.selectEntityById(uuid).pipe(
      filter((entity) => {
        if (!entity) {
          this.entity.getByKey(uuid);
        }
        return !!entity;
      }),
      take(1)
    );
  }
}
